import classNames from 'classnames';
import moment from 'moment-timezone';
import React from 'react';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { Button, Icon } from '../../subkit-ui';
import { getLocalTime, pluralize, sumOfAttr } from '../../utils/helpers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var SessionSummary = function SessionSummary(_ref) {
  var schedule = _ref.schedule,
      shadow = _ref.shadow,
      onSelect = _ref.onSelect;

  var _getLocalTime = getLocalTime(moment(schedule.startsAt)),
      localStartTime = _getLocalTime.localTime;

  var attendeeCount = schedule.bookings ? sumOfAttr(schedule.bookings, 'attendees') : 0;
  var spotsLeft = schedule.capacity - attendeeCount;
  var spotsLeftPluralized = pluralize('spot', 'spots', spotsLeft);
  var availabilityText = schedule.capacity ? "".concat(spotsLeft, " ").concat(spotsLeftPluralized, " left") : 'Unlimited attendees';

  var _useDeviceInfo = useDeviceInfo(),
      mobile = _useDeviceInfo.mobile;

  var handleClick = function handleClick(event) {
    event.preventDefault();
    onSelect && onSelect(schedule);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: classNames('bg-white rounded br-1 p-6 flex flex-col md:flex-row justify-between mb-2  test-session-tab', {
      'border border-neutral-200 ': !shadow,
      'box-shadow': shadow
    }),
    "data-cy": schedule.name
    /*
      Note: We hide book button on screen sizes < lg so we want user to be able to book session by clicking on the card/div
    */
    ,
    onClick: mobile ? handleClick : function () {
      return;
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex flex-col max-w-3xl",
      children: [/*#__PURE__*/_jsx("span", {
        className: "font-medium text-lg break-long-words",
        children: schedule.name
      }), /*#__PURE__*/_jsxs("span", {
        className: "h4 text-gray-900 text-sm md:text-normal",
        "data-cy": "SessionSummaryStartDate",
        children: [/*#__PURE__*/_jsx(Icon, {
          type: "regular",
          name: "calendar-alt",
          className: "mr-1"
        }), "".concat(localStartTime.format('ddd, MMM D, yyyy'), " at ").concat(localStartTime.format('h:mm A z'))]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-full",
        children: /*#__PURE__*/_jsx("div", {
          className: "mt-1 lg:mt-0",
          children: /*#__PURE__*/_jsx("span", {
            className: "text-sm md:text-base mt-2 text-neutral-500",
            children: availabilityText
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "ml-6 flex items-center hidden md:block",
        children: /*#__PURE__*/_jsx(Button, {
          text: "Book",
          onClick: handleClick,
          "data-cy": "session-book-submit"
        })
      })]
    })]
  });
};
SessionSummary.defaultProps = {
  shadow: false
};